<template>
  <div>
    <a-card style="margin: 20px">
      <template #title>
        <div class="top-title">
          <div class="left"><span>汇总结算订单管理</span></div>
          <div class="right">
            <DepartmentChoose :department-code.sync="form.departmentCode"
                              @change="departmentIdchange"></DepartmentChoose>
          </div>
        </div>
      </template>

      <!-- 查询 -->
      <div class="formbox">
        <div class="inputbox">
          <div class="lefttitle">商户号</div>
          <MchChooseDialog v-model="form.mchName" @chooseDone="onMchChosenForQuery"></MchChooseDialog>
        </div>
        <div class="inputbox">
          <div class="lefttitle">店铺号</div>
          <ShopChooseDialog v-model="form.shopName" :mch-no="form.mchNo"
                            @chooseDone="onShopChosenForQuery"></ShopChooseDialog>
        </div>
        <div class="inputbox">
          <div class="lefttitle">合同号</div>
          <a-input v-model.trim="form.contractNo" placeholder="请输入合同号" allowClear style="width: 200px"/>
        </div>
        <div class="inputbox">
          <div class="lefttitle">匹配状态</div>
          <a-select v-model="form.matchStatus" placeholder="请选择匹配状态" allowClear style="width: 200px">
            <a-select-option v-for="o in matchStatusOptions" :key="o.value" :value="o.value">
              <a-tag :color="o.color">{{ o.label }}</a-tag>
            </a-select-option>
          </a-select>
        </div>
        <div class="inputbox">
          <div class="lefttitle">清算状态</div>
          <a-select v-model="form.settleStatus" placeholder="请选择清算状态" allowClear style="width: 200px">
            <a-select-option v-for="o in settleStatusOptions" :key="o.value" :value="o.value">
              <a-tag :color="o.color">{{ o.label }}</a-tag>
            </a-select-option>
          </a-select>
        </div>
        <div class="inputbox">
          <div class="lefttitle">结算日期</div>
          <a-range-picker valueFormat="YYYY-MM-DD" v-model="dateRange"
                          @change="onDateChange" style="width: 240px"
                          :placeholder="['开始日期', '结束日期']"/>
        </div>
        <a-button @click="search" type="primary">查询</a-button>
        <a-button @click="reset" class="reset">重置</a-button>
      </div>

      <!-- 工具栏 -->
      <div class="Toleadinto">
        <a-button-group>
          <a-button @click="openGenerate" type="primary" icon="folder-add"
                    v-if="$authority('consignSummaryGenerate')">汇总生成
          </a-button>
          <a-button @click="goDetail" type="normal" icon="eye"
                    :disabled="selectedRows.length !== 1"
                    v-if="$authority('consignSummaryView')">查看详情
          </a-button>
          <a-button @click="openMatch" type="primary" icon="link"
                    :disabled="!canMatch()"
                    v-if="$authority('consignSummaryMatch')">来账匹配
          </a-button>
          <a-button @click="confirmRepay" type="primary" icon="check"
                    :disabled="!canRepay()"
                    v-if="$authority('consignSummaryRepay')">清算还款
          </a-button>
          <a-button @click="openDelete" type="danger" icon="delete"
                    :disabled="!canDelete()"
                    v-if="$authority('consignSummaryDelete')">作废
          </a-button>
        </a-button-group>
      </div>

      <!-- 表格 -->
      <div class="tablebox">
        <a-table size="small" :row-key="(record) => `${record.id}`" :columns="columns" :data-source="data"
                 :pagination="false" :scroll="{ x: 2200 }"
                 :custom-row="rowClickable">
        </a-table>
      </div>
      <lcfs-pagination :page-no.sync="pagination.pageNo" :page-size.sync="pagination.pageSize"
                       :total="total" :fn="getSummaries"></lcfs-pagination>
    </a-card>

    <!-- 汇总生成 模态框 -->
    <a-modal v-model="generateVisible" title="汇总结算订单生成" @ok="doGenerate" :confirm-loading="generateLoading">
      <a-alert message="仅商户号为必填,店铺/合同缺失不阻塞;协议号空时按 (商户, 店铺) 兜底匹配;已汇总原始单自动跳过" type="info" show-icon
               style="margin-bottom: 16px"/>
      <a-form-model ref="generateForm" :model="generateForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="结算日期" required>
          <a-date-picker v-model="generateForm.settleDate" valueFormat="YYYY-MM-DD"
                         style="width: 100%" placeholder="请选择结算日期"/>
        </a-form-model-item>
        <a-form-model-item label="商户" required>
          <MchChooseDialog v-model="generateForm.mchName"
                           @chooseDone="onMchChosenForGenerate"></MchChooseDialog>
        </a-form-model-item>
        <a-form-model-item label="店铺" optional>
          <ShopChooseDialog v-model="generateForm.shopName"
                            :mch-no="generateForm.mchNo"
                            @chooseDone="onShopChosenForGenerate"></ShopChooseDialog>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 作废 模态框 -->
    <a-modal v-model="deleteVisible" title="作废汇总结算订单" @ok="doDelete" :confirm-loading="deleteLoading">
      <a-alert message="作废后将同步删除银行记录,请确认后再操作" type="warning" show-icon/>
      <a-form-model :model="deleteForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }" style="margin-top: 16px">
        <a-form-model-item label="汇总结算订单号">{{ deleteForm.summaryNo }}</a-form-model-item>
        <a-form-model-item label="作废原因">
          <a-textarea v-model="deleteForm.reason" :rows="3" placeholder="请输入作废原因"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 来账匹配 模态框（勾选流水 + 部分金额） -->
    <a-modal v-model="matchVisible" title="来账匹配" width="65%"
             @ok="doBatchMatch" :confirm-loading="matchLoading"
             :ok-button-props="{ disabled: !canBatchSubmit }">
      <a-alert type="info" show-icon style="margin-bottom: 12px">
        <template #message>
          汇总结算订单号: <b>{{ matchForm.summaryNo }}</b> ｜
          收款账户: <b>{{ matchForm.settleAccountNo }} {{ matchForm.settleAccountName }}</b> ｜
          需结算金额:
          <Balance :amount="matchForm.needSettleAmount" dcflag="c"/>
          ｜
          已匹配金额:
          <Balance :amount="matchForm.matchAmount" dcflag="c"/>
          ｜
          剩余可匹配:
          <Balance :amount="remainingAmount" dcflag="c"/>
        </template>
      </a-alert>

      <!-- 无收款账号时,直接阻断流水查询 -->
      <a-alert v-if="!matchForm.settleAccountNo" type="warning" show-icon
               message="该汇总结算订单无代销收款账号,无法查询银行流水"
               description="汇总结算订单生成时 contractNo 为空会导致收款户为空,请先补办代销协议或作废该汇总结算订单"
               style="margin-bottom: 12px"/>

      <div class="formbox">
        <div class="inputbox">
          <div class="lefttitle">流水日期</div>
          <a-range-picker valueFormat="YYYY-MM-DD" v-model="matchDateRange"
                          @change="loadPayFlows" style="width: 240px"
                          :disabled="!matchForm.settleAccountNo"
                          placeholder="['开始日期','结束日期']"/>
        </div>
        <a-button @click="loadPayFlows" type="primary" :loading="payFlowLoading"
                  :disabled="!matchForm.settleAccountNo">查询流水</a-button>
        <span style="color: #999; font-size: 12px; margin-left: 8px">
          （按代销方收款账户查询,默认近 15 天）
        </span>
      </div>

      <a-table size="small" :columns="payFlowColumns" :data-source="payFlowData"
               :row-selection="payFlowSelection"
               :row-key="r => r.seqNo" :pagination="false"
               :scroll="{ x: 1100, y: 360 }" style="margin-top: 8px">
        <template slot="matchAmount" slot-scope="text, record">
          <a-input-number v-model="record.matchAmount" :min="0" :max="record.transAmount"
                          :precision="2" :disabled="!record.checked" style="width: 140px"/>
        </template>
        <template slot="emptyText">
          <span v-if="!matchForm.settleAccountNo">无收款账号,请先处理汇总结算订单</span>
          <span v-else-if="!payFlowLoading && payFlowData.length === 0">该日期范围内无流水,请调整日期后重试</span>
          <span v-else>暂无数据</span>
        </template>
      </a-table>

      <div class="match-footer">
        <div class="match-footer-left">
          <span>已选 <b style="color: #1890ff">{{ selectedFlows.length }}</b> 笔 ｜</span>
          <span>匹配总金额: <Balance inline :amount="totalMatchAmount" dcflag="c"/> ｜</span>
          <span :class="{ 'over-amount': totalFlowOverrun }">
            剩余可用: <Balance inline :amount="remainingAmount" dcflag="c"/>
          </span>
        </div>
        <div class="match-footer-hint">
          勾选时自动按剩余预算分配匹配金额,可在输入框手动调整
        </div>
      </div>
    </a-modal>

    <!-- 批量匹配结果 模态框 -->
    <a-modal v-model="batchResultVisible" title="批量匹配结果" :width="700" :footer="null">
      <a-alert
          :message="`总计 ${batchResultData.totalCount} 笔,成功 ${batchResultData.successCount} 笔,失败 ${batchResultData.failCount} 笔`"
          :type="batchResultData.failCount > 0 ? 'warning' : 'success'"
          show-icon style="margin-bottom: 12px"/>
      <a-table size="small" :columns="batchResultColumns" :data-source="batchResultData.results"
               :row-key="r => r.index" :pagination="false"/>
    </a-modal>

    <!-- 清算还款 模态框 -->
    <a-modal v-model="repayConfirmVisible" title="清算还款" @ok="doRepay" :confirm-loading="repayLoading">
      <a-alert
          :message="repayForm.matchStatus === '2'
          ? `部分匹配(已匹配 ${repayForm.matchAmount} 元),将部分清算`
          : `全额匹配(已匹配 ${repayForm.matchAmount} 元),将全额清算`"
          :type="repayForm.matchStatus === '2' ? 'warning' : 'info'"
          show-icon style="margin-bottom: 12px"/>
      <p>汇总结算订单号: <b>{{ repayForm.summaryNo }}</b></p>
      <p>需结算金额:
        <Balance :amount="repayForm.needSettleAmount" dcflag="c"/>
      </p>
      <p>实际清算金额: <b style="color: #1890ff">
        <Balance :amount="repayForm.matchAmount" dcflag="c"/>
      </b></p>
      <p style="color: #999; font-size: 12px">*清算操作银行侧幂等,重试安全;失败后可再次点击"清算还款"重试</p>
    </a-modal>

    <!-- 汇总结算订单修正记录 模态框 -->
    <a-modal v-model="revisionVisible" :title="`汇总结算订单修正记录 - ${revisionForm.summaryNo}`"
             :width="1100" :footer="null" :mask-closable="!revisionLoading">
      <a-alert
          :message="`记录银行 310907 每次同步的完整留痕(登记/重试同步,成功/失败/异常),按时间倒序`"
          type="info" show-icon style="margin-bottom: 12px"/>
      <div class="formbox">
        <div class="inputbox">
          <div class="lefttitle">操作类型</div>
          <a-select v-model="revisionFilters.operationType" placeholder="全部" allowClear style="width: 160px"
                    @change="onRevisionFilterChange">
            <a-select-option v-for="o in revisionOperationTypeOptions" :key="o.value" :value="o.value">
              <a-tag :color="o.color">{{ o.label }}</a-tag>
            </a-select-option>
          </a-select>
        </div>
        <div class="inputbox">
          <div class="lefttitle">操作结果</div>
          <a-select v-model="revisionFilters.operationResult" placeholder="全部" allowClear style="width: 160px"
                    @change="onRevisionFilterChange">
            <a-select-option v-for="o in revisionOperationResultOptions" :key="o.value" :value="o.value">
              <a-tag :color="o.color">{{ o.label }}</a-tag>
            </a-select-option>
          </a-select>
        </div>
      </div>
      <a-table size="small" :columns="revisionColumns" :data-source="revisionData"
               :row-key="(record) => record.id" :pagination="false"
               :loading="revisionLoading" :scroll="{ x: 1050 }">
      </a-table>
      <lcfs-pagination
          :page-no.sync="revisionPagination.pageNo"
          :page-size.sync="revisionPagination.pageSize"
          :total="revisionTotal" :fn="loadRevisions">
      </lcfs-pagination>
    </a-modal>

    <!-- 汇总结算订单详情 弹框 -->
    <ConsignSummaryDetail :visible.sync="detailVisible" :summary-no="detailSummaryNo"/>
  </div>
</template>

<script>
import Balance from '@/view/components/Balance.vue'
import DepartmentChoose from '@/view/components/DepartmentChoose.vue'
import LcfsPagination from '@/view/components/LcfsPagination.vue'
import MchChooseDialog from '@/view/components/ChooseDialog/MchChooseDialog.vue'
import ShopChooseDialog from '@/view/components/ChooseDialog/ShopChooseDialog.vue'
import ConsignSummaryDetail from '@/view/consign/summary/view/Detail.vue'
import {matchStatusConfig, settleStatusConfig, summarySyncStatusConfig, revisionOperationTypeConfig, revisionOperationResultConfig, toOptions} from '@/utils/bizDict/consignDict'

export default {
  name: 'ConsignSummaryList',
  components: {LcfsPagination, DepartmentChoose, MchChooseDialog, ShopChooseDialog, Balance, ConsignSummaryDetail},
  data() {
    return {
      selectedRowKeys: [],
      selectedRows: [],
      // 详情弹框控制
      detailVisible: false,
      detailSummaryNo: '',
      total: 0,
      data: [],
      pagination: {pageNo: 1, pageSize: 10},
      // 重试推送按钮 loading 状态(以 summaryNo 为 key,允许多行独立加载)
      syncRetryLoading: null,
      form: {
        mchNo: '',
        mchName: '',
        shopNo: '',
        shopName: '',
        contractNo: '',
        matchStatus: undefined,
        settleStatus: undefined,
        departmentId: undefined,
        departmentCode: '',
        departmentName: '',
        settleDateStart: '',
        settleDateEnd: '',
      },
      dateRange: [],
      matchStatusOptions: toOptions(matchStatusConfig),
      settleStatusOptions: toOptions(settleStatusConfig),
      revisionOperationTypeOptions: toOptions(revisionOperationTypeConfig),
      revisionOperationResultOptions: toOptions(revisionOperationResultConfig),

      // 模态框
      generateVisible: false,
      generateLoading: false,
      generateForm: {settleDate: undefined, mchNo: '', mchName: '', shopNo: '', shopName: ''},
      deleteVisible: false,
      deleteLoading: false,
      deleteForm: {summaryNo: '', reason: ''},
      matchVisible: false,
      matchLoading: false,
      matchForm: {
        summaryNo: '',
        settleAccountNo: '',
        settleAccountName: '',
        channelNo: '',
        appNo: '',
        needSettleAmount: 0,
        matchAmount: 0,
      },
      payFlowData: [],
      payFlowSelected: [],
      matchDateRange: [],
      payFlowLoading: false,
      batchResultVisible: false,
      batchResultData: {totalCount: 0, successCount: 0, failCount: 0, results: []},
      repayConfirmVisible: false,
      repayLoading: false,
      repayForm: {summaryNo: '', needSettleAmount: 0, matchAmount: 0, matchStatus: ''},

      // 修正记录 模态框
      revisionVisible: false,
      revisionLoading: false,
      revisionForm: {summaryNo: ''},
      revisionData: [],
      revisionTotal: 0,
      revisionPagination: {pageNo: 1, pageSize: 10},
      // 修正记录过滤(operationType / operationResult);undefined = 不过滤
      revisionFilters: {operationType: undefined, operationResult: undefined},
    }
  },
  computed: {
    singleSelected() {
      return this.selectedRows.length === 1
    },
    selected() {
      return this.singleSelected ? this.selectedRows[0] : null
    },
    selectedFlows() {
      return this.payFlowData.filter(flow => flow.checked).map(flow => ({
        seqNo: flow.seqNo,
        matchAmount: flow.matchAmount,
        flowTransAmount: flow.transAmount,
      }))
    },
    totalMatchAmount() {
      return this.selectedFlows.reduce(
          (s, f) => s + Number(f.matchAmount || 0), 0
      )
    },
    remainingAmount() {
      return Number(this.matchForm.needSettleAmount || 0)
          - Number(this.matchForm.matchAmount || 0)
    },
    totalFlowOverrun() {
      return this.totalMatchAmount > this.remainingAmount
    },
    canBatchSubmit() {
      return this.selectedFlows.length > 0
          && this.totalMatchAmount > 0
          && !this.totalFlowOverrun
    },
    payFlowColumns() {
      return [
        {title: '银行流水号', dataIndex: 'seqNo', width: 200},
        {title: '来账日期', dataIndex: 'tradeDate', width: 110},
        {title: '本方账号', dataIndex: 'accountNo', width: 170},
        {title: '对方账号', dataIndex: 'oppAccountNo', width: 170},
        {title: '对方户名', dataIndex: 'oppAccountName', width: 130},
        {
          title: '来账金额', dataIndex: 'transAmount', width: 130,
          customRender: (t) => <Balance amount={t} dcflag="c"/>
        },
        {
          title: '匹配金额', key: 'matchAmount', width: 160,
          scopedSlots: {customRender: 'matchAmount'}
        },
        {
          title: '状态', dataIndex: 'status', width: 80,
          customRender: (t) => t === '1'
              ? <a-tag color="green">成功</a-tag>
              : <a-tag color="red">失败</a-tag>
        },
        {
          title: '匹配状态', key: 'matched', width: 150,
          customRender: (t, r) => {
            // 三态:已部分匹配(可继续匹配剩余金额) / 未匹配
            // 全额匹配已被后端过滤掉,前端不会见到 r.matched === true 的情况
            if (r.partialMatchedAmount && Number(r.partialMatchedAmount) > 0) {
              return <a-tag color="orange">
                已部分匹配  ¥{Number(r.partialMatchedAmount).toFixed(2)}

              </a-tag>
              // 给 {r.matchedSummaryNo || ''}
            }
            return <a-tag color="default">未匹配</a-tag>
          }
        },
      ]
    },
    payFlowSelection() {
      return {
        selectedRowKeys: this.payFlowSelected,
        onChange: (keys) => {
          this.payFlowSelected = keys
          const checkedSeqNos = new Set(keys)
          this.payFlowData.forEach(flow => {
            const wasChecked = flow.checked
            const isChecked = checkedSeqNos.has(flow.seqNo)
            flow.checked = isChecked
            // 新勾选的流水:自动分配 matchAmount = min(transAmount, 剩余预算)
            // 避免用户勾 3 笔才发现总额超 — 每勾一笔自动填最大可匹配额
            // 取消勾选时保留 matchAmount,方便用户恢复勾选不丢之前的调整
            if (!wasChecked && isChecked) {
              const otherAllocated = this.payFlowData
                  .filter(other => other.checked && other.seqNo !== flow.seqNo)
                  .reduce((sum, other) => sum + Number(other.matchAmount || 0), 0)
              const budget = Number(this.remainingAmount) - otherAllocated
              flow.matchAmount = Math.max(0, Math.min(Number(flow.transAmount), budget))
            }
          })
        },
        getCheckboxProps: flow => ({
          disabled: flow.status !== '1' || flow.matched === true,
        }),
      }
    },
    batchResultColumns() {
      return [
        {
          title: '#', dataIndex: 'index', width: 60,
          customRender: (t) => Number(t) + 1
        },
        {title: '银行流水号', dataIndex: 'depositSerialNo', width: 220},
        {
          title: '结果', dataIndex: 'success', width: 80,
          customRender: (t) => t
              ? <a-tag color="green">成功</a-tag>
              : <a-tag color="red">失败</a-tag>
        },
        {title: '说明', dataIndex: 'message'},
      ]
    },
    revisionColumns() {
      return [
        {
          title: 'No',
          customRender: (t, r, index) =>
              `${Number(this.revisionPagination.pageNo - 1) * Number(this.revisionPagination.pageSize) + Number(index + 1)}`,
          width: 60,
        },
        {
          title: '操作时间', dataIndex: 'createTime', width: 160,
        },
        {
          title: '操作类型', dataIndex: 'operationType', width: 110,
          customRender: (t) => {
            const c = revisionOperationTypeConfig[t] || revisionOperationTypeConfig.default
            return <a-tag color={c.color}>{c.label}</a-tag>
          },
        },
        {
          title: '操作结果', dataIndex: 'operationResult', width: 100,
          customRender: (t) => {
            const c = revisionOperationResultConfig[t] || revisionOperationResultConfig.default
            return <a-tag color={c.color}>{c.label}</a-tag>
          },
        },
        {
          title: '本次同步状态', dataIndex: 'syncStatus', width: 110,
          customRender: (t) => {
            const c = summarySyncStatusConfig[t] || summarySyncStatusConfig.default
            return <a-tag color={c.color}>{c.label}</a-tag>
          },
        },
        {
          title: '系统流水号', dataIndex: 'sysSerialNo', width: 200,
          customRender: (t) => t || <span style="color: #ccc">-</span>,
        },
        {
          title: '操作备注', dataIndex: 'operationMsg',
          customRender: (t) => t
              ? <a-tooltip title={t}><span class="msg-cell">{t}</span></a-tooltip>
              : <span style="color: #ccc">-</span>,
        },
        {
          title: '操作人', dataIndex: 'creater', width: 100,
          customRender: (t) => t || <span style="color: #ccc">-</span>,
        },
      ]
    },
    columns() {
      return [
        {
          title: '',
          key: 'radio',
          width: 50,
          fixed: 'left',
          customRender: (t, r) => {
            const checked = this.selectedRowKeys.includes(r.id)
            return (
                <a-radio checked={checked}
                         onChange={() => this.onSelectRow(r, true, [r])}/>
            )
          }
        },
        {
          title: 'No',
          customRender: (text, record, index) =>
              `${Number(this.pagination.pageNo - 1) * Number(this.pagination.pageSize) + Number(index + 1)}`,
          width: 60,
        },
        {title: '汇总结算订单号', dataIndex: 'summaryNo', width: 200},
        {title: '商户号', dataIndex: 'mchNo', width: 120},
        {title: '商户名', dataIndex: 'mchName', width: 150},
        {title: '店铺号', dataIndex: 'shopNo', width: 120},
        {title: '合同号', dataIndex: 'contractNo', width: 150},
        {
          title: '需结算金额', dataIndex: 'needSettleAmount', width: 130,
          customRender: (t) => <Balance amount={t} dcflag="c"/>
        },
        {title: '结算日期', dataIndex: 'settleDate', width: 110},
        {
          title: '匹配状态', dataIndex: 'matchStatus', width: 100,
          customRender: (t) => {
            const c = matchStatusConfig[t] || matchStatusConfig.default
            return <a-tag color={c.color}>{c.label}</a-tag>
          }
        },
        {
          title: '匹配金额', dataIndex: 'matchAmount', width: 130,
          customRender: (t) => <Balance amount={t} dcflag="c"/>
        },
        {title: '匹配时间', dataIndex: 'matchTime', width: 160},
        {
          title: '清算状态', dataIndex: 'settleStatus', width: 100,
          customRender: (t) => {
            const c = settleStatusConfig[t] || settleStatusConfig.default
            return <a-tag color={c.color}>{c.label}</a-tag>
          }
        },
        {
          title: '清算金额', dataIndex: 'settleAmount', width: 130,
          customRender: (t) => <Balance amount={t} dcflag="c"/>
        },
        {title: '清算时间', dataIndex: 'settleTime', width: 160},
        {
          title: '银行登记', dataIndex: 'syncStatus', width: 200,
          customRender: (t, r) => {
            const c = summarySyncStatusConfig[t] || summarySyncStatusConfig.default
            // 同步失败时 hover 展示 syncFailMsg
            const tagNode = t === '2' && r.syncFailMsg
                ? <a-tooltip title={r.syncFailMsg}>
                  <a-tag color={c.color}>{c.label}</a-tag>
                </a-tooltip>
                : <a-tag color={c.color}>{c.label}</a-tag>
            // 同步失败时,右侧展示"重试推送"按钮
            if (t === '2') {
              return <div style="display: flex; align-items: center; gap: 4px">
                {tagNode}
                <a-button size="small" type="link" icon="redo"
                          loading={this.syncRetryLoading === r.summaryNo}
                          onClick={() => this.onRetrySync(r)}>
                </a-button>
              </div>
            }
            return tagNode
          }
        },
        {title: '登记时间', dataIndex: 'syncTime', width: 160},
        {
          title: '修正记录', dataIndex: 'summaryNo', key: 'revision', width: 100, fixed: 'right',
          customRender: (t, r) => (
              <a-button size="small" type="link" icon="profile"
                        onClick={() => this.openRevision(r)}>查看记录</a-button>
          )
        },
      ]
    },
  },
  methods: {
    departmentIdchange({departmentId, departmentCode, departmentName}) {
      this.form.departmentId = departmentId
      this.form.departmentCode = departmentCode
      this.form.departmentName = departmentName
    },

    onDateChange(dates) {
      if (dates && dates.length === 2) {
        this.form.settleDateStart = dates[0]
        this.form.settleDateEnd = dates[1]
      } else {
        this.form.settleDateStart = ''
        this.form.settleDateEnd = ''
      }
    },

    onSelectChange(keys, rows) {
      this.selectedRowKeys = keys
      this.selectedRows = rows
    },

    onSelectRow(record, selected, selectedRows) {
      this.selectedRowKeys = (selectedRows || []).map(r => r.id)
      this.selectedRows = selectedRows || []
    },

    rowClickable(record) {
      return {
        on: {
          click: () => this.onSelectRow(record, true, [record])
        },
        style: 'cursor: pointer'
      }
    },

    async getSummaries() {
      const req = {...this.form, ...this.pagination}
      const res = await this.api.summaryPageApi(req)
      if (res.code !== 200) {
        this.$message.error(res.info || '查询失败')
        return
      }
      this.total = res.data.total
      this.data = res.data.records || []
    },

    search() {
      this.pagination.pageNo = 1
      this.getSummaries()
    },

    reset() {
      Object.assign(this.form, {
        mchNo: '', mchName: '', shopNo: '', shopName: '', contractNo: '',
        matchStatus: undefined, settleStatus: undefined,
        settleDateStart: '', settleDateEnd: '',
      })
      this.dateRange = []
      this.search()
    },

    goDetail() {
      if (!this.selected) return
      this.detailSummaryNo = this.selected.summaryNo
      this.detailVisible = true
    },

    canMatch() {
      // syncStatus='1'(银行登记成功) 且 matchStatus ∈ {未匹配, 部分匹配}
      // 不查 settleStatus:match/repay 解耦,各按钮独立,后端不串
      return this.selected
          && this.selected.syncStatus === '1'
          && ['0', '2'].includes(this.selected.matchStatus)
    },
    canRepay() {
      // matchStatus ∈ {已匹配, 部分匹配} 且 settleStatus ∈ {未清算, 清算失败(重试)}
      // 不查 matchStatus 由 match 门控(此处依赖 match 已完成),但后端不强制
      return this.selected
          && ['1', '2'].includes(this.selected.matchStatus)
          && ['0', '9'].includes(this.selected.settleStatus)
    },
    canDelete() {
      return this.selected
          && this.selected.matchStatus === '0'
          && this.selected.settleStatus === '0'
    },

    openGenerate() {
      this.generateForm = {settleDate: undefined, mchNo: '', mchName: '', shopNo: '', shopName: ''}
      this.generateVisible = true
    },

    onMchChosenForGenerate(mch) {
      this.generateForm.mchNo = mch.mchNo
    },
    onShopChosenForGenerate(shop) {
      this.generateForm.shopNo = shop.shopNo
    },
    // 搜索表单 — 商户/店铺选择
    onMchChosenForQuery(mch) {
      this.form.mchNo = mch.mchNo
      this.form.mchName = mch.mchName
    },
    onShopChosenForQuery(shop) {
      this.form.shopNo = shop.shopNo
      this.form.shopName = shop.shopName
    },

    async doGenerate() {
      if (!this.generateForm.settleDate || !this.generateForm.mchNo) {
        this.$message.error('结算日期和商户号必填')
        return
      }
      this.generateLoading = true
      try {
        const res = await this.api.summaryGenerateApi(this.generateForm)
        if (res.code !== 200) {
          this.$message.error(res.info || '生成失败')
          return
        }
        const {generatedCount, skippedCount} = res.data || {}
        this.$message.success(`生成 ${generatedCount || 0} 张,跳过 ${skippedCount || 0} 张`)
        this.generateVisible = false
        this.getSummaries()
      } finally {
        this.generateLoading = false
      }
    },

    openDelete() {
      this.deleteForm = {summaryNo: this.selected.summaryNo, reason: ''}
      this.deleteVisible = true
    },

    async doDelete() {
      this.deleteLoading = true
      try {
        const res = await this.api.summaryDeleteApi(this.deleteForm)
        if (res.code !== 200) {
          this.$message.error(res.info || '作废失败')
          return
        }
        this.$message.success('已作废')
        this.deleteVisible = false
        this.getSummaries()
      } finally {
        this.deleteLoading = false
      }
    },

    openMatch() {
      this.matchForm = {
        summaryNo: this.selected.summaryNo,
        // 账户从汇总结算订单详情拿,本质是商户对应代销协议 consignAccountNo/Name 的快照
        settleAccountNo: this.selected.settleAccountNo || '',
        settleAccountName: this.selected.settleAccountName || '',
        channelNo: this.selected.channelNo || '',
        appNo: this.selected.appNo || '',
        needSettleAmount: this.selected.needSettleAmount || 0,
        matchAmount: this.selected.matchAmount || 0,
      }
      this.payFlowData = []
      this.payFlowSelected = []
      // 流水查询已按账户,与 settleDate 无关;默认今天 ±15 天
      this.matchDateRange = this.defaultDateRange()
      this.matchVisible = true
      this.loadPayFlows()
    },

    defaultDateRange() {
      const base = new Date()
      const start = new Date(base);
      start.setDate(start.getDate() - 15)
      const end = new Date(base);
      end.setDate(end.getDate())
      const fmt = d => d.toISOString().slice(0, 10)
      return [fmt(start), fmt(end)]
    },

    async loadPayFlows() {
      if (!this.matchForm.settleAccountNo) {
        this.$message.error('该汇总结算订单无代销收款账号,无法查询流水')
        return
      }
      this.payFlowLoading = true
      try {
        const [start, end] = this.matchDateRange.length === 2
            ? this.matchDateRange
            : this.defaultDateRange()
        const res = await this.api.payFlowListApi({
          accountNo: this.matchForm.settleAccountNo,
          accountName: this.matchForm.settleAccountName,
          channelNo: this.matchForm.channelNo,
          appNo: this.matchForm.appNo,
          startDate: start,
          endDate: end,
        })
        if (res.code !== 200) {
          this.$message.error(res.info || '查询流水失败')
          this.payFlowData = []
          return
        }
        this.payFlowData = (res.data || []).map(flow => ({
          ...flow,
          checked: false,
          matchAmount: flow.transAmount,
        }))
        this.payFlowSelected = []
      } finally {
        this.payFlowLoading = false
      }
    },

    async doBatchMatch() {
      if (!this.canBatchSubmit) {
        if (this.selectedFlows.length === 0) {
          this.$message.error('请至少勾选一笔流水')
        } else if (this.totalMatchAmount <= 0) {
          this.$message.error('匹配总金额必须大于 0')
        } else if (this.totalFlowOverrun) {
          this.$message.error('匹配总金额超过剩余可匹配金额')
        }
        return
      }
      this.matchLoading = true
      try {
        const res = await this.api.summaryBatchMatchApi({
          items: this.selectedFlows.map(f => ({
            summaryNo: this.matchForm.summaryNo,
            depositSerialNo: f.seqNo,
            matchAmount: f.matchAmount,
            flowTransAmount: f.flowTransAmount,
          })),
        })
        if (res.code !== 200) {
          this.$message.error(res.info || '匹配失败')
          return
        }
        const data = res.data || {totalCount: 0, successCount: 0, failCount: 0, results: []}
        if (data.failCount === 0) {
          this.$message.success(`全部匹配成功,共 ${data.successCount} 笔`)
          this.matchVisible = false
        } else if (data.successCount === 0) {
          this.$message.error(`全部匹配失败,共 ${data.failCount} 笔`)
          this.batchResultData = data
          this.batchResultVisible = true
        } else {
          this.$message.warning(
              `部分成功:成功 ${data.successCount} 笔,失败 ${data.failCount} 笔,请查看详情`
          )
          this.batchResultData = data
          this.batchResultVisible = true
        }
        this.getSummaries()
      } finally {
        this.matchLoading = false
      }
    },

    confirmRepay() {
      this.repayForm = {
        summaryNo: this.selected.summaryNo,
        needSettleAmount: this.selected.needSettleAmount,
        matchAmount: this.selected.matchAmount || 0,
        matchStatus: this.selected.matchStatus,
      }
      this.repayConfirmVisible = true
    },

    async doRepay() {
      this.repayLoading = true
      try {
        const res = await this.api.summaryRepayApi({summaryNo: this.repayForm.summaryNo})
        if (res.code !== 200) {
          this.$message.error(res.info || '清算失败')
          return
        }
        this.$message.success('清算成功')
        this.repayConfirmVisible = false
        this.getSummaries()
      } finally {
        this.repayLoading = false
      }
    },

    // 银行登记重试:对 syncStatus='2' 的行,重新调 310907
    // per-row loading:不阻塞其他行的重试按钮
    async onRetrySync(record) {
      if (!record || !record.summaryNo) return
      // 二次确认:防止误点
      this.$confirm({
        title: '重试推送银行',
        content: `汇总结算订单号 ${record.summaryNo} 重新调 310907 银行登记,是否继续?`,
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          this.syncRetryLoading = record.summaryNo
          try {
            const res = await this.api.summarySyncRetryApi({summaryNo: record.summaryNo})
            if (res.code !== 200) {
              this.$message.error(res.info || '重试同步失败')
            } else {
              this.$message.success('已重新同步银行')
            }
            this.getSummaries()
          } finally {
            this.syncRetryLoading = null
          }
        },
      })
    },

    // 打开修正记录模态框:按 summaryNo 拉银行 310907 同步历史
    openRevision(record) {
      this.revisionForm = {summaryNo: record.summaryNo}
      this.revisionPagination = {pageNo: 1, pageSize: 10}
      // 重置过滤条件,避免上次打开的过滤状态残留
      this.revisionFilters = {operationType: undefined, operationResult: undefined}
      this.revisionVisible = true
      this.loadRevisions()
    },

    // 过滤条件变化:重置到第 1 页,重新拉取
    onRevisionFilterChange() {
      this.revisionPagination.pageNo = 1
      this.loadRevisions()
    },

    // 拉取该汇总结算订单的修正记录(分页,createTime 倒序)
    async loadRevisions() {
      if (!this.revisionForm.summaryNo) return
      this.revisionLoading = true
      try {
        const res = await this.api.summaryRevisionPageApi({
          ...this.revisionForm,
          ...this.revisionFilters,
          ...this.revisionPagination,
        })
        if (res.code !== 200) {
          this.$message.error(res.info || '查询修正记录失败')
          this.revisionData = []
          this.revisionTotal = 0
          return
        }
        this.revisionTotal = res.data ? res.data.total : 0
        this.revisionData = res.data ? (res.data.records || []) : []
      } finally {
        this.revisionLoading = false
      }
    },
  },
  mounted() {
    Object.assign(this.form, this.$route.query)
    this.getSummaries()
  },
  // keep-alive 缓存下,从 Detail.vue 返回时不会重新 mounted
  // 用 activated 识别 fromDetailPage 触发列表刷新
  activated() {
    if (this.$route.query.fromDetailPage) {
      this.selectedRowKeys = []
      this.selectedRows = []
      this.getSummaries()
    }
  },
}
</script>

<style scoped>
.top-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.top-title .left span {
  font-weight: 600;
}

.formbox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
}

.inputbox {
  display: flex;
  align-items: center;
  gap: 8px;
}

.lefttitle {
  width: 80px;
  color: #666;
}

.Toleadinto {
  margin: 12px 0;
}

.tablebox {
  margin-top: 8px;
}

.reset {
  margin-left: 8px;
}

.match-footer {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 8px 12px;
  margin-top: 8px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  font-size: 13px;
  color: #333;
}

.match-footer-left {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
}

.match-footer-left > span {
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
}

.match-footer-hint {
  color: #999;
  font-size: 12px;
  margin-left: auto;
  text-align: right;
}

.match-footer .over-amount {
  color: #ff4d4f;
  font-weight: 600;
}

.msg-cell {
  display: inline-block;
  max-width: 360px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
</style>
